import React, {  useState } from 'react'
import { Link, } from 'react-router-dom'

function Header() {
    const [showHam, setShowHam] = useState(true);

    function handleClick(e) {
        const hamburger = document.querySelector('.hamburger');
        const header = document.querySelector('.header');
        const ul = document.querySelector('.ul');
        const dropdown_content = document.querySelector('.dropdown-content');
        hamburger.classList.toggle("hamburgerClicked");
        header.classList.toggle("headerr");
        ul.classList.toggle("ull");
        dropdown_content.classList.toggle("dropdown-contentt");
        if (e.target.classList.value.includes("clicked")) {
            setShowHam(false);
            e.target.classList.toggle("clicked")
        } else {
            setShowHam(true);
        }
    }

  return (
    <div>
        <header className='header'>
        <Link className='chartLink' to="/"><h1>ChatApp</h1></Link>
                <nav>
                    <ul className="ul">
                        <Link className='ulLink' to="/about"><li style={window.location.pathname==="/about"?{color:"black"}:{color:"white"}}>About</li></Link>
                        <Link className='ulLink' to="/contact"><li style={window.location.pathname==="/contact"?{color:"black"}:{color:"white"}}>Contact</li></Link>
                        <div className="dropdown">
                            <Link className='ulLink' to={window.location.pathname}><li>Signin</li></Link>
                            <div className="dropdown-content">
                                <div className="drpdown">
                                    <Link className='dropdownbtn' to='/login'>Signin</Link>
                                </div>
                                <span>New to ChatApp? <Link className='navsignup' to='/register'>Register</Link></span>

                            </div>
                        </div>
                    </ul>
                </nav>
                <div onClick={handleClick} className="hamburger ">
                    {showHam ? <i className="clicked fa-solid fa-bars"></i>
                        :
                        <i className="i2 fa-solid fa-xmark"></i>}
                </div>
            </header>
    </div>
  )
}

export default Header